﻿import { Language, TranslationMode } from '@lingvo-news/contracts';
import { parseLanguageParam, parseModeParam } from '../router/parseLanguageParam';
import { useRoute } from 'vue-router';

export interface CommonRouteParams {
	nativeLanguage: Language;
	learnedLanguage: Language;
	mode: TranslationMode;
}

export interface ParsedCommonRouteParams {
	readonly nativeLanguage: Language | null;
	readonly learnedLanguage: Language | null;
	readonly mode: TranslationMode | null;
}

export function parseCommonRouteParamsFromParams(params: Record<string, unknown>): ParsedCommonRouteParams {
	return {
		nativeLanguage: parseLanguageParam(params.nativeLanguage),
		learnedLanguage: parseLanguageParam(params.learnedLanguage),
		mode: parseModeParam(params.mode),
	};
}

export function useCommonRouteParams(): CommonRouteParams {
	const route = useRoute();

	function mustGetLanguageParam(value: unknown): Language {
		const lang = parseLanguageParam(value);
		if (lang) return lang;
		throw new Error('Invalid or missing language route param');
	}

	function mustGetModeParam(value: unknown): TranslationMode {
		const mode = parseModeParam(value);
		if (mode) return mode;
		throw new Error('Invalid or missing mode route param');
	}

	const nativeLanguage = mustGetLanguageParam(route.params.nativeLanguage);
	const learnedLanguage = mustGetLanguageParam(route.params.learnedLanguage);
	const mode = mustGetModeParam(route.params.mode);

	return {
		nativeLanguage,
		learnedLanguage,
		mode
	};
}
